/* jshint esversion: 6 */
import utils from "../libs/utils";
const group = "home";

const model = {
	CURRENT_CITY: {}, // H5定位记录
	AD_CODE: 0, // H5adcode
	CURRENT_CITY_MIN: {}, // 小程序定位记录
	AD_CODE_MIN: 0, // 小程序adcode
	IS_PIOLICity:'',//是否是试点城市
	CART_NUMBER:null, // 购物车数量
};

export const types = utils.genTypes(model, group);
export const state = utils.genState(model, group);
export const getters = utils.genGetters(types);
export const mutations = utils.genMutations(types);

mutations[types.RESET] = (s) => {
	Object.keys(s).forEach((key) => {
		s[key] = state[key];
	});
};

export const actions = {
	// 存入H5定位记录
	[types.CURRENT_CITY](store, location) {
		let currentCity = JSON.parse(JSON.stringify(store.getters[types.CURRENT_CITY]));
		currentCity = location;
		store.commit(types.CURRENT_CITY, currentCity);
	},
	// 存入H5定位code
	[types.AD_CODE](store, adcode) {
		let adCode = JSON.parse(JSON.stringify(store.getters[types.AD_CODE]));
		adCode = adcode;
		store.commit(types.AD_CODE, adCode);
	},
	// 存入小程序定位记录
	[types.CURRENT_CITY_MIN](store, location) {
		let currentCity = JSON.parse(JSON.stringify(store.getters[types.CURRENT_CITY_MIN]));
		currentCity = location;
		store.commit(types.CURRENT_CITY, currentCity);
	},
	// 存入小程序定位code
	[types.AD_CODE_MIN](store, adcode) {
		let adCode = JSON.parse(JSON.stringify(store.getters[types.AD_CODE_MIN]));
		adCode = adcode;
		store.commit(types.AD_CODE, adCode);
	},
	//试点城市
	[types.IS_PIOLICity](store,ispioltCity) {
		store.commit(types.IS_PIOLICity,ispioltCity)
	},
	// 购物车数量
	[types.CART_NUMBER](store,number) {
		store.commit(types.CART_NUMBER,number)
	},
	// [types.CART_NUMBER](store, query) {
	// 	return checkCart(query,'jsonCallback').then((res) => {
	// 		return res.data;
	// 	});
	// },
};
